import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class SlackWebhookService {

    constructor(private http: HttpClient) {
    }

    hitWebhook(webhookUrl: string, text: string): Observable<string> {
        return this.http.post(webhookUrl, JSON.stringify({
            text: text,
        }), {
            responseType: 'text',
        });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/slack-webhook.service.ts